import React, { useState } from 'react'
import { Breadcrumb, Layout, Tag } from 'antd'
import { IcEdit, IcTrash } from 'assets/icons'
import { Button } from 'components'
import KategoriInspeksiComponent from './components/KategoriInspeksiComponent'
import ModalDeleteKategoriInspeksi from './components/ModalDeleteKategoriInspeksi'
import { useHistory } from 'react-router-dom'
import { useQuery } from 'react-query'
import { apiDelete, apiGet } from 'api'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from 'store/actions'

const initialTableState = {
  totalRows: 0,
  offset: 0,
  limit: 10,
  keywords: '',
  listData: [],
  sort_by: 'id',
  sort_order: null
}

const KategoriInspeksi = () => {
  const token = useSelector((state) => state.auth.token)
  const dispatch = useDispatch()
  const router = useHistory()
  const [modalDelete, setModalDelete] = useState({
    show: false,
    data: {}
  })
  const [tableState, setTableState] = useState(initialTableState)
  const columns = [
    {
      name: 'Kategori',
      selector: (row) => row?.name,
      width: '220px',
      sortable: true
    },
    {
      name: 'Sub-Kategori',
      selector: (row) => row?.updated_at,
      cell: (row) => (
        <div className="flex flex-wrap mt-2">
          {row?.inspectionSubCategories?.map((data) => (
            <Tag
              key={`subkategori-${data?.id?.toString()}`}
              className="px-2 py-[2px] border-0 bg-[#FEECE2] rounded-lg text-[#A21226] mb-2 selection:text-black">
              {data?.name}
            </Tag>
          ))}
        </div>
      )
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '100px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <Button
            className="bg-white border-gray-300 mr-2 hover:bg-gray-50 flex items-center"
            onClick={() =>
              router.push('/master/inspeksi/kategori-inspeksi/edit', { data: row, type: 'edit' })
            }>
            <IcEdit className="text-gray-700" size={18} />
          </Button>
          <Button
            className="bg-white border-solid border-[#FDA19B] hover:bg-red-50"
            onClick={() => setModalDelete({ show: true, data: row })}>
            <IcTrash className="text-primary-500" size={16} />
          </Button>
        </div>
      )
    }
  ]

  const { isLoading, refetch } = useQuery({
    queryKey: [
      'category-list',
      tableState.offset,
      tableState.limit,
      tableState.sort_by,
      tableState.sort_order,
      tableState.keywords
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        keywords: tableState.keywords,
        offset: tableState.offset,
        limit: tableState.limit,
        sort_by: tableState.sort_by,
        sort_order: tableState.sort_order
      }
      const res = await apiGet({
        url: `inspeksi-service/admin/inspection-categories`,
        data: params,
        token,
        onLogout: () => dispatch(logout())
      })
      return res
    },
    onSuccess: (res) => {
      setTableState({
        ...tableState,
        listData: res?.resData?.data,
        totalRows: res?.resData?.meta?.total
      })
    }
  })

  const deleteData = async (data) => {
    try {
      let res
      res = await apiDelete({
        url: `inspeksi-service/admin/inspection-categories/${data?.id}`,
        token
      })
      if (res?.resStatus === 200 || res?.resStatus === 201) {
        setModalDelete({
          ...modalDelete,
          show: false
        })
        refetch()
      }
    } catch (error) {
      setModalDelete({
        ...modalDelete,
        show: false
      })
    }
  }

  return (
    <Layout style={{ padding: '0 24px 24px', background: '#F5F5F5' }}>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Master Data</Breadcrumb.Item>
        <Breadcrumb.Item>Inspeksi</Breadcrumb.Item>
        <Breadcrumb.Item>Kategori Inspeksi</Breadcrumb.Item>
      </Breadcrumb>
      <ModalDeleteKategoriInspeksi
        isOpen={modalDelete.show}
        data={modalDelete.data}
        onSubmit={deleteData}
        onCancel={() => setModalDelete({ ...modalDelete, show: false })}
      />
      <KategoriInspeksiComponent
        isLoading={isLoading}
        columns={columns}
        data={tableState?.listData}
        tableState={tableState}
        setTableState={setTableState}
      />
    </Layout>
  )
}

export default KategoriInspeksi
